export function getOrderStatusBadge(status) {
  switch (status) {
    case "CHO_SALES_XAC_NHAN_THIEU":
      return "badge-danger";
    case "DANG_CHUAN_BI_HANG":
      return "badge-warning";
    case "SAN_SANG_GIAO":
      return "badge-secondary";
    case "DANG_VAN_CHUYEN":
      return "badge-primary";
    case "HOAN_THANH":
      return "badge-success";
    case "DA_HUY":
      return "badge-dark";
    default:
      return "badge-light";
  }
}

export function formatOrderStatus(status) {
  switch (status) {
    case "CHO_SALES_XAC_NHAN_THIEU":
      return "Chờ Sales (Thiếu hàng)";
    case "DANG_CHUAN_BI_HANG":
      return "Kho đang chuẩn bị";
    case "SAN_SANG_GIAO":
      return "Sẵn sàng (Hàng đợi)";
    case "DANG_VAN_CHUYEN":
      return "Đang vận chuyển";
    case "HOAN_THANH":
      return "Hoàn thành";
    case "DA_HUY":
      return "Đã hủy";
    default:
      return status;
  }
}
